import { FundingKey, FundingType } from '@bytel/leviator';

import { PlanPrice } from '@services/products';

import { DiscountEnumType } from '@app-types/discount';
import { IFundingDetail } from '@app-types/funding';
import { ProductChildFull } from '@app-types/product';

import { getDiscountValue } from '@helpers/product';

export type PricesDetails = {
    productPrices: {
        marketingAmount: number;
        fundingMonthlyAmount: number;
        todayPrice: number;
        odrRefund: number;
        initialPriceTTC: number;
    };
    planPrices?: PlanPrice;
    funding?: {
        type: FundingKey;
        installmentCount: number;
        interestAmount: number;
        label: string;
    };
};

export function getPricesDetails(
    currentProduct?: ProductChildFull,
    selectedFunding?: IFundingDetail,
    planPrice?: PlanPrice,
): PricesDetails {
    const fixedPriceTTC =
        currentProduct?.details?.fundings?.find((f) => f.type === FundingType.COMPTANT)?.amountToFinance ?? 0;
    const initialPriceTTC = currentProduct?.details?.price?.initial ?? fixedPriceTTC;
    const odrRefundTTC = getDiscountValue(currentProduct?.details?.discounts ?? [], DiscountEnumType.ODR) ?? 0;

    const productMainAmountTTC = Math.max(
        selectedFunding ? (selectedFunding.initialContributionWithOdr ?? 0) : fixedPriceTTC - odrRefundTTC,
        1,
    );

    const todayProductPriceTTC =
        (selectedFunding?.initialDeposit ? selectedFunding.initialDeposit : fixedPriceTTC) ?? 0;

    const fundingMonthlyAmountTTC = selectedFunding?.monthlyAmount ?? 0;

    const odrRefund = odrRefundTTC * -1;

    return {
        productPrices: {
            marketingAmount: productMainAmountTTC,
            fundingMonthlyAmount: fundingMonthlyAmountTTC,
            todayPrice: todayProductPriceTTC,
            initialPriceTTC,
            odrRefund,
        },
        planPrices: planPrice,
        ...(selectedFunding && {
            funding: {
                type: selectedFunding.key,
                installmentCount: selectedFunding.installments ?? 0,
                interestAmount: selectedFunding.interestAmount,
                label: selectedFunding.label,
            },
        }),
    };
}
